import React from "react";
import { Twitter, Facebook, Linkedin, Link2, Download, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function ShareBar({ shareUrl, title, imageUrl, testId }) {
  const text = title || "I just got my AI facial analysis on Aesthetiq";
  const enc = encodeURIComponent;

  const links = [
    { name: "X", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(shareUrl)}` },
    { name: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(shareUrl)}` },
    { name: "LinkedIn", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(shareUrl)}` },
    { name: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${enc(text + " " + shareUrl)}` },
    { name: "Reddit", icon: MessageCircle, href: `https://www.reddit.com/submit?url=${enc(shareUrl)}&title=${enc(text)}` },
  ];

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "Aesthetiq", text, url: shareUrl });
        return;
      } catch (e) { /* cancelled */ }
    }
    copyLink();
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied to clipboard");
    } catch (e) {
      toast.error("Could not copy link");
    }
  };

  const downloadImage = () => {
    if (!imageUrl) return;
    const a = document.createElement("a");
    a.href = imageUrl;
    a.download = "aesthetiq-facecard.png";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      <button
        onClick={nativeShare}
        data-testid="share-native-btn"
        className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition hover:brightness-110"
      >
        <Link2 className="h-4 w-4" /> Share result
      </button>
      {links.map((l) => (
        <a
          key={l.name}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Share on ${l.name}`}
          data-testid={`share-${l.name.toLowerCase()}-btn`}
          className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-border bg-card text-muted-foreground transition hover:border-primary/60 hover:text-foreground"
        >
          <l.icon className="h-4 w-4" />
        </a>
      ))}
      <button
        onClick={copyLink}
        aria-label="Copy link"
        data-testid="share-copy-btn"
        className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-border bg-card text-muted-foreground transition hover:border-primary/60 hover:text-foreground"
      >
        <Link2 className="h-4 w-4" />
      </button>
      {imageUrl && (
        <button
          onClick={downloadImage}
          aria-label="Download card"
          data-testid="share-download-btn"
          className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-border bg-card text-muted-foreground transition hover:border-primary/60 hover:text-foreground"
        >
          <Download className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
